import React from 'react';
import {question} from 'react-icons-kit/icomoon/question';
import SvgIcon from 'react-icons-kit';
import swal from 'sweetalert';

var Config = require('../../config');

let getDocument = (e, menu, submenu, modal)=>{
	e.preventDefault();

	var obj ={
		menu:menu,
		submenu:submenu
	}
	modal.handleShow('Cargando');
	fetch(Config.default.apiGateway.URL+'help_documents/print',{ 
	    method: 'post',
	    body:JSON.stringify(obj),
	    headers: new Headers({
	       	'Authorization': 'Bearer '+sessionStorage.getItem('token'),
			'Content-Type': 'application/json'
	    })
	})
	.then(res => {
		modal.handleClose();
		if(res.ok){
			return res.blob();
		}else{
			res.text().then((msg)=>{
				swal('Error', msg, 'error');
			})
			
		}
	})
	.then(response => {
		if(response !== undefined){
			var fileURL = URL.createObjectURL(response);
			window.open(fileURL);
		}	
			
	})
}

const Help = (props)=>{
	return <div style={{float:'right', position:'absolute', left:'97%', zIndex:'1000'}}>
		<SvgIcon 
			icon={question} 
			size={30} 
			style={{color:'var(--base1)', cursor:'pointer'}}
			onClick={(e)=>getDocument(e, props.menu, props.submenu, props.waiting)}
		/>

		
	</div>
}

export default Help;